import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CircledCheckmarkIcon: React.FC<Props> = ({
  color,
  ...svgProps
}) => {
  return (
    <SVG
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 22)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
    >
      <path d="M20.5 11a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Z" />
      <path
        d="M11 20.4a9.4 9.4 0 1 0 0-18.8 9.4 9.4 0 0 0 0 18.8Z"
        strokeWidth="2"
      />
      <path
        d="m6.6 11.2 3.2 3.4 5.6-7.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};
